import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class Authguard implements CanActivate {

  constructor(
    private authService: AuthService, 
    private router: Router
  ) {}

  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return true;
  // }
  // canActivate(): boolean {
  //   if (this.authService.isLoggedIn()) {
  //     return true;
  //   } else {
  //     this.router.navigate(['/login-pelanggan']);
  //     return false;
  //   }
  // }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Mengecek apakah pengguna sudah login dengan memeriksa localStorage
    const user = localStorage.getItem('user_pelanggan');

    if (user) {
      // Pengguna sudah login
      return true;
    } else {
      // Pengguna belum login, arahkan ke halaman login
      this.router.navigate(['/login-pelanggan']);
      return false;
    }
  }
}
